import React from 'react';
import { NavLink } from 'react-router-dom';

const TABS = [
  { to: '/promo-codes', label: 'Promo Codes' },
  { to: '/banners', label: 'Banners' },
];

/**
 * Tab strip shared by the Promo Codes and Banners list pages
 * ("Promo Codes | Banners"), matching the Figma design.
 */
export const PromoTabs: React.FC = () => (
  <div className="border-b border-gray-200 mb-6">
    <nav className="-mb-px flex space-x-6">
      {TABS.map(tab => (
        <NavLink
          key={tab.to}
          to={tab.to}
          className={({ isActive }) =>
            `whitespace-nowrap border-b-2 py-3 px-1 text-sm font-medium transition-colors ${
              isActive
                ? 'border-alps-primary text-alps-primary'
                : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
            }`
          }
        >
          {tab.label}
        </NavLink>
      ))}
    </nav>
  </div>
);
